// extracted by mini-css-extract-plugin
module.exports = {"root":"ShippingInfo_root__Qnk7Q","text":"ShippingInfo_text___54ub","circle":"ShippingInfo_circle__6gv8q"};